// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as AuthVm$PorterinFeature from "../../../view-model/AuthVm.mjs";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as NextImage$PorterinFeature from "../../../../../ui/components/NextImage.mjs";
import * as CityContext$PorterinFeature from "../../../../../contexts/city-context/CityContext.mjs";
import * as AuthHeaderModuleScss from "../../styles/AuthHeader.module.scss";
import * as PublishEventsHelper$PorterinFeature from "../../../../../shared/core/helpers/PublishEventsHelper.mjs";

var styles = AuthHeaderModuleScss;

function AuthHeaderCmp(Props) {
  var show_close_iconOpt = Props.show_close_icon;
  var close_modal = Props.close_modal;
  var show_close_icon = show_close_iconOpt !== undefined ? show_close_iconOpt : false;
  var match = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var category = match.category;
  return React.createElement("div", {
              className: styles.header
            }, React.createElement("div", {
                  className: styles.logo,
                  onClick: (function (param) {
                      PublishEventsHelper$PorterinFeature.publishEvents(category, AuthStore$PorterinFeature.Header.ga_login_modal_close, undefined);
                      Curry._1(close_modal, undefined);
                    })
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: AuthVm$PorterinFeature.header_logo.src,
                      height: AuthVm$PorterinFeature.header_logo.height,
                      width: AuthVm$PorterinFeature.header_logo.width,
                      quality: 100.0,
                      alt: AuthVm$PorterinFeature.header_logo.alt
                    })), show_close_icon ? React.createElement("div", {
                    className: styles["close-icon"],
                    onClick: (function (param) {
                        PublishEventsHelper$PorterinFeature.publishEvents(category, AuthStore$PorterinFeature.Header.ga_login_modal_close, undefined);
                        Curry._1(close_modal, undefined);
                      })
                  }, React.createElement(NextImage$PorterinFeature.make, {
                        src: AuthVm$PorterinFeature.close_icon.src,
                        height: AuthVm$PorterinFeature.close_icon.height,
                        width: AuthVm$PorterinFeature.close_icon.width,
                        quality: 100.0,
                        alt: AuthVm$PorterinFeature.close_icon.alt
                      })) : null);
}

var make = AuthHeaderCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
